export const SURVEY_DETAIL_TRANSLATE = {
  BTN_CHANGE_SURVEY: "アンケート表示",
  BTN_EDIT: "編集",
};
